import React,{useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';

const AssociateServiceAttributesForm = (props) => {
    const { formData, formValidateError,isButtonLoader } = props;

    const [ attributeList, setAttributeList] = useState([]);
    const [ serviceAttributeAssociate, setServiceAttributeAssociate] = useState({});

    const [ finalData, setFinalData ] = useState({});


    const selectAttributeOnChange = (serviceName, field, selectedValue) => {
        setServiceAttributeAssociate(prev => ({
            ...prev,
            [serviceName]: {
              ...prev[serviceName],
              [field]: selectedValue
            }
        }));
    }

    let serviceAttributeAssociateHtml = '';
    if(formData['step4'].service_setup.length > 0){
        serviceAttributeAssociateHtml = formData['step4'].service_setup
            .filter(service => !formData['step4'].service_attributes_association.hasOwnProperty(service.service_name))
            .map((service) => {
            return (
                <tr key={uuidv4()}>
                    <td>{service.service_name}</td>
                    <td>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select'
                            options={attributeList}
                            placeholder='Select an option' 
                            isMulti
                            onChange={(selectedOptions) =>
                                selectAttributeOnChange(service.service_name, 'attribute_list', selectedOptions)
                            }
                            value={serviceAttributeAssociate[service.service_name]?.attribute_list || []}
                        />
                    </td>
                    <td>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select'
                            options={[
                                { label : 'Yes' , value : 'Yes' },
                                { label : 'No' , value : 'No' }
                            ]}
                            placeholder='Select an option'
                            onChange={(selectedOption) =>
                                selectAttributeOnChange(service.service_name, 'attributes_to_be_filled', selectedOption)
                            }
                            value={serviceAttributeAssociate[service.service_name]?.attributes_to_be_filled || null}
                        />
                    </td>
                </tr>
            );
        });
    }

    useEffect(() => {
        if (formData['step4'].attribute_setup.length > 0) {
            const transformedArray = formData['step4'].attribute_setup.map(item => ({
                label: item.attribute,
                value: item.attribute
            }));
            setAttributeList(transformedArray);
        }
        else{
            setAttributeList([]);
        }
    }, [formData['step4'].attribute_setup]);

    const serviceAttributeAssociateSave = () => {

        if(Object.keys(serviceAttributeAssociate).length === 0){
            toast.error('All field are required.');
            return
        }

        const rmBlankArray = Object.fromEntries(
            Object.entries(serviceAttributeAssociate).filter(
                ([key, value]) => value.attribute_list && value.attribute_list.length > 0
            )
        );

        if(Object.keys(rmBlankArray).length === 0){
            toast.error('Attribute list is required.');
            return
        }
        for (const key in rmBlankArray) {
            const item = rmBlankArray[key];
            if(!item.attributes_to_be_filled){
                toast.error('Attribute to be filled is required.');
                return
            }
        }
        props.serviceAttributeAssociateSave(rmBlankArray)
        setServiceAttributeAssociate([])
    }

    return (
        <>
            {
                Object.keys(formData['step4'].service_attributes_association).length !==
                formData['step4'].service_setup.length &&
                <div className='row'>
                    <div className='col-md-12'>
                        <table className="table table-row-dashed table-row-gray-300">
                            <thead>
                                <tr className="fw-bolder fs-6 text-gray-800">
                                    <th className='w-200px'>Service</th>
                                    <th style={{width: '600px'}}>Attribute</th>
                                    <th>All attributes to be filled?</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceAttributeAssociateHtml}
                            </tbody>
                        </table>
                    </div>
                    <div className='col-md-12 text-end'>
                        <div 
                            className="btn btn-dark btn-icon btn-sm" 
                            onClick={serviceAttributeAssociateSave}
                        >
                            {
                                isButtonLoader ?
                                <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    </div>
                    <div className='col-md-12 mt-5'>
                            {
                                formValidateError?.service_attributes_association &&
                                <AlertMessage
                                    sub_title = {formValidateError?.service_attributes_association}
                                    type = 'danger'
                                />
                            }
                        </div>
                </div>
            }
        </>
    )
}

export default AssociateServiceAttributesForm